import { render } from "./ModalComponent.vue?vue&type=template&id=13d1dda4"
import script from "./ModalComponent.vue?vue&type=script&lang=js"
export * from "./ModalComponent.vue?vue&type=script&lang=js"

import "./ModalComponent.vue?vue&type=style&index=0&id=13d1dda4&lang=css"
script.render = render

export default script